<div class="download-modal-screen" *ngIf="showModal">
    <div class="modal-overlay">
        <div class="modal-body">
            <div class="modal-header">
                <div class="header-title lato-18-n-vw">DOWNLOAD ARTIFACT</div>
                <div class="close-icon" (click)="closeDeleteModal()" cygovSvgIcon
                    [svgName]="'x-icon-type2'"></div>
            </div>

            <div *ngIf="showConfirmDialogBox && allFiles.length != 0"
                class="modal-download-content">
                <div class="download-message">
                    <span *ngIf="allFileNames.length === 1" class="message-text lato-18-n-vw">Please
                        note you are about to download the artifact:</span>

                    <span *ngIf="allFileNames.length > 1" class="message-text lato-18-n-vw">
                        Please note you are about to download artifacts of control</span>



                    <span class="artifact-name lato-18-n-vw">{{ allFileNames.length > 1 ?
                        controlName : allFileNames[0] }}</span>
                </div>

                <div class="button-row">
                    <button type="button" (click)="downloadFiles()"
                        class="btn btn-primary uppercase add-entity-btn btn-confirm lato-14-n-vw">
                        CONFIRM
                    </button>
                    <button type="button" (click)="closeDeleteModal()"
                        class="btn btn-primary uppercase add-entity-btn btn-cancel lato-14-n-vw">
                        CANCEL
                    </button>
                </div>
            </div>

            <div *ngIf="!confirmDownloadFlag && !showSuccessMessage && showConfirmDialogBox && allFiles.length === 0"
                class="no-files">
                <span class="lato-20-b-vw">No Files to download</span>
            </div>

            <div *ngIf="showSuccessMessage">
                <div class="success-content-container">
                    <div cygovSvgIcon [svgName]="'download-complete-tick'"></div>

                    <div class="button-row">
                        <span>The {{ artifactText }} downloaded successfully!</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>